
<script>
import { sharefriend } from '@/utils/share'
import dataConfig from '@/dataConfig';
export default {
	name: 'App',
	template: `<div id='app'>${process.env.channel === 'pc' ? dataConfig.pc.html : dataConfig.h5.html}</div>`,
	mounted () {
		// this.mounteCss();
		this.share()
		// gotoApp('http://xinyue.qq.com/act/a20181108hmsj/index.html')
		const pvKey = `${process.env.channel}_${this.$actConfig.actId}`;
		// this.$mtaH5.clickStat(pvKey);
		this.$TaAndMTA({}, pvKey)
	},
	methods: {
		share () {
			if (navigator.userAgent.toLowerCase().indexOf('tgclub') === -1) {
				let _helpKey = 0
				Object.keys(this.$actConfig.shareData).forEach((key) => {
					if (this.$actConfig.shareData[key] !== '') {
						_helpKey++
					}
				})
				if (_helpKey >= 7) {
					sharefriend(this.$actConfig.shareData)
				}
			}
		},
	}
}
</script>

<style>
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue